import { useI18n } from "hooks/i18n/i18n";

import { STATUS } from "./constants/status";

import type { Props } from "./props";
import type { Status } from "./types/status";

type Input = Props;
type Output = {
  text: string;
};
type UseStatusLabel = (input: Input) => Output;

export const useThis: UseStatusLabel = (input) => {
  const { status } = input;
  const { t } = useI18n();
  const textMap: Record<Status, string> = {
    [STATUS.NO_LABEL]: "",
    // 販売系
    [STATUS.A_FEW_LEFT]: t("ui.statusLabel.sale.aFewLeft"),
    [STATUS.BEFORE_SALE]: t("ui.statusLabel.sale.beforeOnSale"),
    [STATUS.END]: t("ui.statusLabel.sale.end"),
    [STATUS.NEW]: t("ui.statusLabel.sale.new"),
    [STATUS.ON_SALE]: t("ui.statusLabel.sale.onSale"),
    [STATUS.SOLD_OUT]: t("ui.statusLabel.sale.soldOut"),
    // 発送系
    [STATUS.PREPARING_SHIPMENT]: t("ui.statusLabel.shipment.preparingShipment"),
    [STATUS.SHIPPED]: t("ui.statusLabel.shipment.shipped"),
    // イベント系
    [STATUS.BEFORE_EVENT]: t("ui.statusLabel.event.beforeEvent"),
    [STATUS.DURING_EVENT]: t("ui.statusLabel.event.duringEvent"),
    [STATUS.EVENT_ENDED]: t("ui.statusLabel.event.eventEnded"),
  };

  return {
    text: textMap[status],
  };
};
